import styles from './table.module.scss';
import React, {CSSProperties} from 'react';
import {Alignment} from '../../enums/alignment.ts';
import {classNames} from '../../support/classnames.ts';

interface OwnProps {
    children?: React.ReactNode;
    alignment?: Alignment;
    isKeyValue?: boolean;
    style?: CSSProperties;
}

export function Table({children, alignment, isKeyValue, style}: OwnProps) {
    return (
        <div
            style={style}
            className={classNames(styles.table, {
                [styles.align_left]: alignment === Alignment.Start,
                [styles.key_value]: isKeyValue,
            })}
        >
            {children}
        </div>
    );
}
